import { ref } from 'vue'

const showingErrorType = ref('') // 今現在表示されているエラーのType エラーが複数来た際の制御用
const showError = ref(false)
const errorTitle = ref('システムエラーが発生しました')
const errorMessage = ref('予期せぬエラーのため再度操作をお試しください')
const errorBlackText = ref('症状が改善されない場合は 担当者までご連絡ください')
const color = ref('red')

export const useError = () => {
  const toggleShowError = (state, type) => {
    // トークンエラーが表示されているときに他のエラーを表示したくない
    if (showingErrorType.value === 'token' && state) return

    if (state) {
      showingErrorType.value = type != null ? type : 'other'
    } else {
      showingErrorType.value = ''
    }

    showError.value = state

    // 初期化
    errorTitle.value = ''
    errorMessage.value = ''
    errorBlackText.value = ''
    color.value = 'red'

    if (type == null) {
      errorTitle.value = 'システムエラーが発生しました'
      errorMessage.value = '予期せぬエラーのため再度操作をお試しください'
      errorBlackText.value = '症状が改善されない場合は 担当者までご連絡ください'
      color.value = 'red'
    } else if (type == 'auth') {
      errorTitle.value = 'ログインに失敗しました'
      errorMessage.value = 'IDとパスワードを確認してください'
      color.value = 'blue'
    } else if (type == 'token') {
      errorTitle.value = 'ログインの有効期限が切れました'
      errorMessage.value = '操作を続ける場合は再度ログインしてください'
      errorBlackText.value = ''
      color.value = 'blue'
    } else if (type == 'download') {
      errorTitle.value = 'ダウンロードに失敗しました'
      errorMessage.value = ''
      errorBlackText.value = ''
      color.value = 'purple'
    }
    // if (type == 'XXX') {
    // errorTitle.value = 'タイトルに表示したいテキスト'
    // errorMessage.value = 'エラー内容に表示したいテキスト'
    // errorBlackText.value = 'エラー内容下の半透明黒色テキスト'
    // color.value = 'ダイアログの色'
    // }
  }

  return {
    toggleShowError,
    showError,
    errorTitle,
    errorMessage,
    color,
    errorBlackText,
  }
}
